export default {
    coconut: require('./coconut/coconut.svg'),
    paperplane: require('./paperplane/paperplane.svg'),
    suitcase: require('./suitcase/suitcase.svg'),
    bigInfo: require('./bigInfo/info.svg'),
    likeIcon: require('./icon-like/icon-100-like.svg'), 
    errorIcon: require('./icon-error/icon-120-error.svg')
};
